export const isNullOrUndef = (x) => {
    return x === null || x === undefined;
};
